export const siteUrl = assertValue(
  process.env.NEXT_PUBLIC_SITE_URL,
  'Missing environment variable: NEXT_PUBLIC_SITE_URL'
);

export const siteName = assertValue(
  process.env.NEXT_PUBLIC_SITE_NAME,
  'Missing environment variable: SITE_NAME'
);

export const env = assertValue(
  process.env.NEXT_PUBLIC_STAGE,
  'Missing environment variable: NEXT_PUBLIC_STAGE'
);

// Shopify

export const shopifyStoreId = assertValue(
  process.env.NEXT_PUBLIC_SHOPIFY_STORE_ID,
  'Missing environment variable: NEXT_PUBLIC_SHOPIFY_STORE_ID'
);

export const shopifyStoreDomain = assertValue(
  process.env.NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN,
  'Missing environment variable: NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN'
);

export const shopifyAccountsURL = assertValue(
  process.env.NEXT_PUBLIC_SHOPIFY_ACCOUNTS_URL,
  'Missing environment variable: NEXT_PUBLIC_SHOPIFY_ACCOUNTS_URL'
);

// Sanity

export const sanityApiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2025-03-25';

export const sanityDataset = assertValue(
  process.env.NEXT_PUBLIC_SANITY_DATASET,
  'Missing environment variable: NEXT_PUBLIC_SANITY_DATASET'
);

export const sanityProjectId = assertValue(
  process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  'Missing environment variable: NEXT_PUBLIC_SANITY_PROJECT_ID'
);

export const sanityStudioUrl = assertValue(
  process.env.NEXT_PUBLIC_SANITY_STUDIO_URL,
  'Missing environment variable: NEXT_PUBLIC_SANITY_STUDIO_URL'
);

// Algolia

export const algoliaAppId = assertValue(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  'Missing environment variable: NEXT_PUBLIC_ALGOLIA_APP_ID'
);

export const algoliaSearchApiKey = assertValue(
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY,
  'Missing environment variable: NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY'
);

export const algoliaIndexNameFR = assertValue(
  process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME_FR,
  'Missing environment variable: NEXT_PUBLIC_ALGOLIA_INDEX_NAME_FR'
);

export const algoliaIndexNamePT = assertValue(
  process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME_PT,
  'Missing environment variable: NEXT_PUBLIC_ALGOLIA_INDEX_NAME_PT'
);

// GA4

export const gaMeasurementId = assertValue(
  process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
  'Missing environment variable: NEXT_PUBLIC_GA_MEASUREMENT_ID'
);

// Clarity

export const clarityProjectId = assertValue(
  process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID,
  'Missing environment variable: NEXT_PUBLIC_CLARITY_PROJECT_ID'
);

function assertValue<T>(v: T | undefined, errorMessage: string): T {
  if (v === undefined) {
    throw new Error(errorMessage);
  }

  return v;
}
